<template>
  <div class="dft-attr_container">
    <h4 class="dft-header">营销活动</h4>
    <!-- 商品 -->
    <div class="attr-item-box" v-for="(item, index) in value.attrsort" :key="index"
      :style="{ 'padding': value.attr[item].isUse == false ? '0' : '6px' }">
      <div class="attr-item-typedata" v-if="item == 'a0'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="addImgList" v-if="value.attr['a1s'].value=='1'">
            <div class="imgList_box">
              <!-- <draggable tag="div" class="cardDrag-list-wrap comp-list" v-if="gprefresh" v-model="item.value" :group="groupRight"
                animation="100" delay="10" :sort="true"> -->
                <div class="attr-list-item comp-item groupitem" v-for="(iitem, iiIndex) in value.attr[item].groupList.slice(0,1)" :key="iitem.groupId">
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label">活动类型</div>
                    <el-select class="active-input-give" style="width: 100%;" v-model="iitem.activityCode" @change="(val)=>{setactivity(val,iitem)}">
                      <el-option
                        v-for="alitem in activityList"
                        :key="alitem.value"
                        :label="alitem.label"
                        :value="alitem.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label">分类标题</div>
                    <el-input v-model="iitem.activityTitle" style="width: 100%;flex: 1;padding-right: 12px;" @pointerdown.stop.native></el-input>
                  </div>
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label" style="width: 60px;flex-shrink: 0;padding-bottom: 4px;">商品分类</div>
                    <div class="clear_box"><el-button size="mini" @click="clearC(iitem.categoryList)">清空</el-button></div>
                    <div class="g_taglist" v-if="iitem.categoryList">
                      <el-tag
                        :key="tag.id"
                        v-for="(tag,iiindex) in iitem.categoryList.filter(item=>item.level!=0)"
                        closable class="ctag_item"
                        :disable-transitions="false"
                        @close="handleTagClose(iitem.categoryList,iiindex)">
                        {{tag.categoryName}}
                      </el-tag>
                    </div>
                    <div class="upload_btn" @click="addClass(iiIndex)" style="margin-top: 8px;">
                      <i class="el-icon-plus"></i>
                      新增分类
                    </div>
                    <addClassPage
                      :ref="`addClassPage_${iitem.groupId}`"
                      :key="iitem.groupId"
                      v-model="iitem.categoryList"
                      :showDialog="showClassDialog&&showClassIndex==iiIndex"
                      @goBack="goBack"
                    ></addClassPage>
                  </div>
                  <div class="ii-link-btn">
                    <i class="el-icon-top icon_btn" title="上移" v-if="iiIndex != 0" @click="moveUp(value.attr[item].groupList,iiIndex)"></i>
                    <i class="el-icon-bottom icon_btn" title="下移" v-if="iiIndex != (value.attr[item].groupList.length - 1)" @click="moveDown(value.attr[item].groupList,iiIndex)"></i>
                    <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(value.attr[item].groupList,iiIndex)"></i>
                  </div>
                </div>
              <!-- </draggable> -->
            </div>
            <div class="upload_btn select_btn" @click="addCroup(value.attr[item].groupList)"
              :style="value.attr[item].groupList.length>=1?{'cursor': 'not-allowed','margin-top': '8px'}:'margin-top: 8px;'">
              <i class="el-icon-plus"></i>
              新增活动类型
            </div>
          </div>
          <div class="addImgList" v-else>
            <div class="imgList_box">
              <!-- <draggable tag="div" class="cardDrag-list-wrap comp-list" v-if="gprefresh" v-model="item.value" :group="groupRight"
                animation="100" delay="10" :sort="true"> -->
                <div class="attr-list-item comp-item groupitem" v-for="(iitem, iiIndex) in value.attr[item].groupList" :key="iitem.groupId">
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label">活动类型</div>
                    <el-select class="active-input-give" style="width: 100%;" v-model="iitem.activityCode" @change="(val)=>{setactivity(val,iitem)}">
                      <el-option
                        v-for="alitem in activityList"
                        :key="alitem.value"
                        :label="alitem.label"
                        :value="alitem.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label">分类标题</div>
                    <el-input v-model="iitem.activityTitle" style="width: 100%;flex: 1;padding-right: 12px;" @pointerdown.stop.native></el-input>
                  </div>
                  <div class="goodsinfo groupitem_line">
                    <div class="g_l_label" style="width: 60px;flex-shrink: 0;padding-bottom: 4px;">商品分类</div>
                    <div class="clear_box"><el-button size="mini" @click="clearC(iitem.categoryList)">清空</el-button></div>
                    <div class="g_taglist" v-if="iitem.categoryList">
                      <el-tag
                        :key="tag.id"
                        v-for="(tag,iiindex) in iitem.categoryList.filter(item=>item.level!=0)"
                        closable class="ctag_item"
                        :disable-transitions="false"
                        @close="handleTagClose(iitem.categoryList,iiindex)">
                        {{tag.categoryName}}
                      </el-tag>
                    </div>
                    <div class="upload_btn" @click="addClass(iiIndex)" style="margin-top: 8px;">
                      <i class="el-icon-plus"></i>
                      新增分类
                    </div>
                    <addClassPage
                      :ref="`addClassPage_${iitem.groupId}`"
                      :key="iitem.groupId"
                      v-model="iitem.categoryList"
                      :showDialog="showClassDialog&&showClassIndex==iiIndex"
                      @goBack="goBack"
                    ></addClassPage>
                  </div>
                  <div class="ii-link-btn">
                    <i class="el-icon-top icon_btn" title="上移" v-if="iiIndex != 0" @click="moveUp(value.attr[item].groupList,iiIndex)"></i>
                    <i class="el-icon-bottom icon_btn" title="下移" v-if="iiIndex != (value.attr[item].groupList.length - 1)" @click="moveDown(value.attr[item].groupList,iiIndex)"></i>
                    <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(value.attr[item].groupList,iiIndex)"></i>
                  </div>
                </div>
              <!-- </draggable> -->
            </div>
            <div class="upload_btn select_btn" @click="addCroup(value.attr[item].groupList)"
              :style="value.attr[item].groupList.length>=2?{'cursor': 'not-allowed','margin-top': '8px'}:'margin-top: 8px;'">
              <i class="el-icon-plus"></i>
              新增活动类型
            </div>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-else-if="item == 'a1s'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <el-radio-group v-model="value.attr[item].value" size="small" @change="handleModeChange">
              <el-radio-button label="1">模式一</el-radio-button>
              <el-radio-button label="2">模式二</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-if="item == 'a1'&&value.attr['a1s'].value=='1'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <div class="temp-item" :class="value.attr[item].value == iiIndex ? 'active_temp-item' : ''"
              v-for="(ii, iiIndex) in value.attr[item].options" :key="iiIndex" @click="value.attr[item].value = iiIndex">
              <el-image v-if="value.attr[item].value == iiIndex && ii.img1" class="temp-item-img" :src="ii.img1"
                fit="contain"></el-image>
              <el-image v-else-if="ii.img2" class="temp-item-img" :src="ii.img2" fit="contain"></el-image>
              <div class="temp-item-name"><span class="mini_span">{{ ii.name }}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="attr-item-typedata" v-else-if="item == 'a2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <el-radio-group v-model="value.attr[item].value" size="small">
              <el-radio-button label="1">无边白底</el-radio-button>
              <el-radio-button label="2">卡片投影</el-radio-button>
              <el-radio-button label="3">描边白底</el-radio-button>
              <el-radio-button label="4">无边透明底</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a16'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-select v-model="value.attr[item].value" placeholder="请选择" style="width: 160px;">
            <el-option label="样式1" value="1" class="select-option"></el-option>
            <el-option label="样式2" value="2" class="select-option"></el-option>
            <el-option label="样式3" value="3" class="select-option"></el-option>
            <el-option label="样式4" value="4" class="select-option"></el-option>
            <el-option label="样式5" value="5" class="select-option"></el-option>
            <el-option label="样式6" value="6" class="select-option"></el-option>
            <el-option label="样式7" value="7" class="select-option"></el-option>
            <el-option label="样式8" value="8" class="select-option"></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="item == 'a16' && ['3', '4', '7', '8'].includes(value.attr[item].value)"
        class="flex justify-end align-center col-center row-center">
        <span style="font-size: 12px;">按钮文字：</span>
        <el-input v-model="value.attr[item].options[value.attr[item].value]" style="width: 120px;"></el-input>
      </div>
      <div class="attr-item-typestyle" v-else-if="value.attr[item].isUse != false && ['a1t','a10','a11label','a11sp','a12','a13','a14','a15','a17','a18','a20','a21'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">显示</el-radio-button>
            <el-radio-button label="2">不显示</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" style="position: relative;padding-bottom: 12px;"
        v-else-if="item == 'a11'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">显示</el-radio-button>
            <el-radio-button label="2">不显示</el-radio-button>
          </el-radio-group>
        </div>
        <div class="info-set">此处显示商品的 ”分享描述“ 内容。</div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a3b'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="unset">直角</el-radio-button>
            <el-radio-button label="16px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a3'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="unset">直角</el-radio-button>
            <el-radio-button label="8px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a4'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="66.67%">3:2</el-radio-button>
            <el-radio-button label="100%">1:1</el-radio-button>
            <el-radio-button label="133.33%">3:4</el-radio-button>
            <el-radio-button label="56.25%">16:9</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a5'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="cover">填充</el-radio-button>
            <el-radio-button label="contain">留白</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a6'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="400">常规</el-radio-button>
            <el-radio-button label="600">加粗</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a7'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="left">左对齐</el-radio-button>
            <el-radio-button label="center">居中对齐</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a8','a9'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-slider v-model="value.attr[item].value" :min="value.attr[item].min" :max="value.attr[item].max" show-input :show-input-controls="false"
            class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a19'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">隐藏</el-radio-button>
            <el-radio-button label="2">不隐藏</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-if="['a2p'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'

export default {
  components: {
    draggable,
    addClassPage,
  },
  props: {
    value: {
      type: Object,
      default: ()=>{
        return {attr:{},attrsort:[]}
      }
    },
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data() {
    return {
      showDialog: false,
      showClassDialog: false,
      showSKDialog: false,
      gprefresh: true,
      showClassIndex: 0,
      showSKIndex: 0,
      activityList:[
        { label: '今日优惠', value: '1'},
        { label: '新品展示', value: '2'},
        { label: '爆款专区', value: '3'},
        { label: '新人专享', value: '4'},
        { label: '好物推荐', value: '5'},
        { label: '会员专区', value: '6'},
        // { label: '拼团', value: '7'},
        // { label: '砍价', value: '8'},
      ],
      groupRight: {
        name: 'itxst2',
        pull: false,  // 拖出
        put: false,   // 拖入
      },
      // 模板默认数据-16
      assemblyAttr666: JSON.stringify(
            {
              attr: {
                a0: {
                  label: '添加活动', value: [], key: 'goodsList', type: 'data', tag: '', sid:'goods_weapp_s0',
                  groupList:[{
                    activityName: '',
                    activityCode: '',
                    activityTitle: '',
                    categoryList: [],
                  }],
                },
                a1s: {
                  label: '展示模式', value: '1', key: 'modetype', type: 'data', tag: '', sid:'goods_weapp_s2',
                  showList: {
                    '1':'模式一',
                    '2':'模式二',
                  },
                },
                a1: {
                  label: '列表样式', value: 1, key: 'listStyle', type: 'data', tag: '', sid:'goods_weapp_s1',
                  options: [
                    {name:'一行一个',img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png'},
                    {name:'一行两个',img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png'},
                    {name:'一行三个',img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png'},
                    {name:'大图模式',img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png'},
                    {name:'横向滑动',img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png'},
                    {name:'一大两小',img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png',img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png'},
                  ],
                },
                
                a1t: { 
                  label: '活动标题', value: '1', sid:'goods_weapp_s5',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a2p: {
                  label: '背景颜色', value: '#fff4f3', sid:'attr_s',
                  showList: {},default:'#fff4f3',
                  key: 'background', type: 'style', tag: 'ColorPicker'
                },
                a2: {
                  label: '商品样式', value: '4', key: 'goodsStyle', type: 'data', tag: '', sid:'goods_weapp_s2',
                  showList: {
                    '1':'无边白底',
                    '2':'卡片投影',
                    '3':'描边白底',
                    '4':'无边透明底',
                  },
                },
                a3b: {
                  label: '整体倒角', value: '16px', sid:'g',
                  showList: {
                    'unset':'直角',
                    '16px':'圆角'
                  },
                  key: 'border-radius', type: 'style', tag: 'radio'
                },
                a3: { 
                  label: '商品倒角', value: 'unset', sid:'goods_weapp_s6',
                  showList: {
                    'unset':'直角',
                    '8px':'圆角'
                  },
                  key: 'border-radius', type: 'style', tag: 'radio'
                },
                a4: { 
                  label: '图片比例', value: '66.67%', sid:'goods_weapp_s7',
                  showList: {
                    '66.67%':'3:2',
                    '100%':'1:1',
                    '133.33%':'3:4',
                    '56.25%':'16:9'
                  },
                  key: 'padding-top', type: 'style', tag: 'radio'
                },
                a5: { 
                  label: '图片填充', value: 'cover', sid:'goods_weapp_s8',
                  showList: {
                    'cover':'填充',
                    'contain':'留白',
                  },
                  key: 'fit', type: 'style', tag: 'radio'
                },
                a6: { 
                  label: '文本样式', value: '400', sid:'goods_weapp_s9',
                  showList: {
                    '400':'常规',
                    '600':'加粗',
                  },
                  key: 'font-weight', type: 'style', tag: 'radio'
                },
                a7: { 
                  label: '文本对齐', value: 'left', sid:'goods_weapp_s10',
                  showList: {
                    'left':'左对齐',
                    'center':'居中对齐'
                  },
                  key: 'text-align', type: 'style', tag: 'radio'
                },
                a8: { 
                  label: '页面边距', value: 8, sid:'goods_weapp_s11',
                  min: 0, max: 30,
                  key: 'padding', type: 'style', tag: 'el-slider'
                },
                a9: { 
                  label: '商品间距', value: 8, sid:'goods_weapp_s11',
                  min: 0, max: 30,
                  key: 'padding', type: 'style', tag: 'el-slider'
                },
                a10: { 
                  label: '商品名称', value: '1', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsName', type: 'style', tag: 'radio'
                },
                a11: { 
                  label: '商品描述', value: '2', sid:'goods_weapp_s5',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a12: { 
                  label: '商品价格', value: '1', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsPrice', type: 'style', tag: 'radio'
                },
                a13: { 
                  label: '商品原价', value: '1', sid:'goods_weapp_s4', 
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsOldPrice', type: 'style', tag: 'radio'
                },
                a14: { 
                  label: '商品销量', value: '1', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'goodsSaleNum', type: 'style', tag: 'radio',
                },
                a15: { 
                  label: '购买按钮', value: '1', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'btnStyle', type: 'style', tag: 'select'
                },
                a16: { 
                  label: '按钮样式', value: '1', sid:'goods_weapp_s3',
                  showList: {
                    '1':'样式1',
                    '2':'样式2',
                    '3':'样式3',
                    '4':'样式4',
                    '5':'样式5',
                    '6':'样式6',
                    '7':'样式7',
                    '8':'样式8'
                  },
                  options: {
                    '1':'',
                    '2':'',
                    '3':'马上抢',
                    '4':'购买',
                    '5':'',
                    '6':'',
                    '7':'马上抢',
                    '8':'购买'
                  },
                  key: 'btnText', type: 'style', tag: 'button'
                },
                a17: { 
                  label: '倒计时', value: '2', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'countdown', type: 'style', tag: 'radio'
                },
                a18: { 
                  label: '进度条', value: '2', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
                a19:{ 
                  label: '已售罄商品', value: '2', sid:'goods_weapp_s12',
                  showList: {
                    '1':'隐藏',
                    '2':'不隐藏'
                  },
                  key: 'goodsTag', type: 'style', tag: 'radio'
                },
                // a20: { 
                //   label: '已团人数', value: '1', sid:'goods_weapp_s4',
                //   showList: {
                //     '1':'显示',
                //     '2':'不显示'
                //   },
                //   key: 'progress', type: 'style', tag: 'radio'
                // },
                a21: { 
                  label: '显示分类', value: '2', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
                a22: {
                  label: '显示更多', value: '2', sid:'goods_weapp_s4',
                  showList: {
                    '1':'显示',
                    '2':'不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
              },
              attrsort: [
                'a0','a1s','a1','a1t','a2','a2p','a21','a22','a3b','a3','a4','a5','a6','a7','a8','a9',
                'a10','a11','a12','a13','a14','a17',
              ]
            }
          )
    };
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created() {
  },

  mounted() {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData() {
    },
    addClass(index) {
      this.showClassIndex = index
      this.showClassDialog = true
      console.log('??-0',index,this.showClassDialog&&this.showClassIndex==index)
    },
    clearC(val){
      val.splice(0,val.length)
    },
    addSK(index) {
      console.log('??-1',index)
      this.showSKIndex = index
      this.showSKDialog = true
    },
    //模式变更
    handleModeChange(val){
      if(val == '2'){
        this.value.attr['a1'].value = 2
      }
      console.log('/././.---',val,this.value)
    },
    handleTagClose(value, i){
      value.splice(i, 1)
    },
    addCoupon(list) {
      this.showDialog = true
    },
    addCroup(groupList) {
      if(this.value.attr['a1s'].value=='1'&&groupList.length>=1 || this.value.attr['a1s'].value=='2'&&groupList.length>=2){
        return
      }
      groupList.push(
        {
          groupId: `gp${Math.floor(Math.random()*10e9)}`,
          activityName: '',
          activityCode: '',
          activityTitle: '',
          categoryList: [
            {
              categoryName: '全部',
              level: 0
            }
          ],
        }
      )
      this.gprefresh = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.gprefresh = true
        }, 100);
      });
    },
    setactivity(val,iitem){
      const _i = this.activityList.findIndex(iii=>iii.value == val)
      iitem.activityName = this.activityList[_i].label
      iitem.activityTitle = this.activityList[_i].label
    },
    // 存储秒杀商品
    // 上移
    moveUp(value,iiIndex){
      value[iiIndex] = value.splice(iiIndex-1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown(value,iiIndex){
      value[iiIndex] = value.splice(iiIndex+1, 1, value[iiIndex])[0]
    },
    // 删除
    mDelete(value, iiIndex) {
      value.splice(iiIndex, 1)
    },
    goBack(val) {
      // this.$refs.addCouponPage.dialogVisible = false
      // console.log('l;l;',val)
      this.showDialog = false
      this.showClassDialog = false
      this.showSKDialog = false
    },
  },
};
</script>

<style lang="scss" scoped>
// @import url(../storecommonattr.less);
.dft-attr_container {
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
  }
  
  .dft-header {
    margin: 5px 0;
  }
  
  .attr-item-box {
    padding: 6px 6px;
  
    .attr-item-typedata {
      margin-bottom: 10px;
  
      .attr-item-label {
        margin-bottom: 5px;
        font-size: 14px;
      }
  
      .attr-item-value {
        .temp-box {
          display: flex;
          flex-wrap: wrap;
  
          .temp-item {
            width: calc((100% - 36px)/6);
            height: 90px;
            margin: 0 3px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
  
            .temp-item-img {
              width: 48px;
              height: 48px;
              margin-bottom: 8px;
            }
  
            .temp-item-name {
              font-weight: 400;
              font-size: 11px;
              line-height: 20px;
              text-align: center;
              color: #333;
  
              .mini_span {
                /*transform: scale(.7);*/
              }
            }
          }
  
          .active_temp-item {
            .temp-item-name {
              color: #155bd4;
            }
          }
        }
  
        .addImgList {
          width: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
  
          .img_info {
            color: #969799;
            font-weight: 400;
            margin-top: 8px;
            white-space: pre-wrap;
            font-size: 13px;
          }
  
          .imgList_box {
            width: 100%;
            box-sizing: border-box;
            overflow-y: auto;
  
            .imgList-item {
              border: 1px solid #e0e0e0;
              margin: 12px 5px;
              padding: 4px;
              box-sizing: border-box;
              display: flex;
  
              .ii-img-box {
                width: 80px;
                height: 100px;
                position: relative;
  
                .ii-img {
                  width: 100%;
                  height: 100%;
                }
  
                .ii-img-btn {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 20px;
                  background-color: rgba($color: #000000, $alpha: .5);
                  text-align: center;
                  font-size: 13px;
                  color: #ffffff;
                  cursor: pointer;
                }
              }
  
              .ii-link-box {
                width: calc(100% - 80px);
                box-sizing: border-box;
                height: 100px;
                padding: 0 8px;
  
                .ii-link-info {
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: #999;
                }
  
                .ii-link {}
              }
            }
          }
  
          .upload_btn {
            background: #efefef;
            border-radius: 2px;
            padding: 6px 10px 6px 14px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            width: -webkit-fit-content;
            width: -moz-fit-content;
            width: fit-content;
            margin: 0 auto;
            color: #333;
            cursor: pointer;
          }
  
          .comp-item {
            width: calc(100% - 12px);
            margin: 8px 6px;
            padding: 6px 10px 6px 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            border-radius: 2px;
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);
  
            .goodsinfo {
              padding-left: 8px;
              font-size: 13px;
            }
  
            /*cursor: grab;*/
            position: relative;
          }
          .groupitem{
            flex-direction: column;
            position: relative;
            background: #fcfcfc;
            .groupitem_line{
              width: 100%;
              margin: 6px 0;
              background: #fff;
              position: relative;
              .ctag_item{
                margin-right: 4px;
              }
            }
            .g_l_label{
              flex-shrink: 0;
              padding-bottom: 4px;
              color: #969799;
            }
            .clear_box{
              position: absolute;
              top: 1px;
              right: 8px;
              width: 100%;
              margin-bottom: 6px;
              display: flex;
              justify-content: flex-end;
              .el-button{
                padding: 0 8px;
                height: 26px;
              }
            }
            .g_taglist{
              margin-top: 8px;
            }
            .ii-link-btn{
              position: absolute;
              top: 2px;
              right: 4px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              font-size: 18px;
              color: #969696;
              display: none;
              
              .icon_btn {
                font-size: 18px;
                padding: 2px;
                margin: 0 2px;
                cursor: pointer;
                &:hover{
                  color: #155bd4;
                }
              }
            }
            &:hover {
              .ii-link-btn {
                display: flex;
              }
            }
          }
          .select_btn {
            width: 100%;
            margin: 8px 0 0;
            box-sizing: border-box;
            background-color: #fff;
            border: 1px solid #155bd4;
            border-radius: 2px;
            color: #155bd4;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  
    .attr-item-typestyle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      margin-bottom: 10px;
  
      .attr-item-label {
        color: #333333;
        margin-right: 12px;
      }
  
      .attr-item-on {
        color: #333333;
        margin-right: 8px;
        font-size: 12px;
      }
  
      .attr-item-value {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  
  }
  
  .colorPicker {
    height: 40px;
    display: flex;
    align-items: center;
  }
  
  .custon_slider {
    width: 100%;
  
    /deep/.el-slider__input {
      width: 60px;
    }
  
    /deep/.el-slider__runway.show-input {
      margin-left: 8px;
      margin-right: 80px;
    }
  }
  
  .btn-icon {
    line-height: 20px;
    color: #f44;
  }
  
  .select-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .select-btn {
    height: 18px;
    padding: 0 8px;
  }
  
  .info-set {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #969799;
    font-size: 12px;
  }
</style>
